var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 7,
    viewBox: "0 0 12 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.46202 0.292021L5.58202 4.17202L1.70202 0.292021C1.60944 0.199439 1.49953 0.125999 1.37856 0.0758944C1.2576 0.0257894 1.12795 5.02798e-08 0.997021 4.35812e-08C0.86609 3.68825e-08 0.736442 0.0257894 0.615478 0.0758944C0.494513 0.125999 0.384603 0.199439 0.292021 0.292021C0.199439 0.384603 0.125999 0.494513 0.0758939 0.615478C0.0257889 0.736442 -3.88335e-08 0.86609 -4.35812e-08 0.997021C-4.83288e-08 1.12795 0.0257888 1.2576 0.0758938 1.37856C0.125999 1.49953 0.199439 1.60944 0.292021 1.70202L4.88202 6.29202C5.27202 6.68202 5.90202 6.68202 6.29202 6.29202L10.882 1.70202C10.9747 1.60951 11.0483 1.49962 11.0985 1.37865C11.1486 1.25767 11.1745 1.12799 11.1745 0.997021C11.1745 0.866053 11.1486 0.73637 11.0985 0.615397C11.0483 0.494424 10.9747 0.384535 10.882 0.292021C10.492 -0.0879787 9.85202 -0.0979788 9.46202 0.292021Z",
    fill: "#0071B9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/chevron-down.ef56648764ffffafeb00ad34db4188e0.svg";
export { ForwardRef as ReactComponent };